module.exports = __webpack_public_path__ + "img/battery_pv_power_on.fd09eb72.png";